import { SerializedNodes } from "@craftjs/core";

export const ContentPage: SerializedNodes = {
    ROOT: {
        type: { resolvedName: "Page" },
        isCanvas: true,
        props: { title: "Untitled Page", language: "int-en", pageType: "Step1" },
        displayName: "Page",
        custom: { displayName: "Page" },
        hidden: false,
        nodes: ["dsCVJyOHPj", "PAGE_CONTENT", "as3Ks2b4d"],
        linkedNodes: {},
        parent: null,
    },
    dsCVJyOHPj: {
        type: { resolvedName: "PageHeader" },
        isCanvas: true,
        props: { step: "1" },
        displayName: "Header",
        custom: { canDelete: false, displayName: "Header Section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
    PAGE_CONTENT: {
        type: { resolvedName: "PageContent" },
        isCanvas: true,
        props: { filters: false },
        displayName: "Content",
        custom: { canDelete: false, displayName: "Content section" },
        parent: "ROOT",
        hidden: false,
        nodes: ["cQYSvL7VWy"],
        linkedNodes: {},
    },
    cQYSvL7VWy: {
        type: { resolvedName: "PageContentContainer" },
        isCanvas: true,
        props: { filters: "no", tags: "no" },
        displayName: "Container",
        custom: { canDelete: true, displayName: "Container" },
        parent: "PAGE_CONTENT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
    as3Ks2b4d: {
        type: { resolvedName: "Spotlight" },
        isCanvas: true,
        props: { nextStep: "2" },
        displayName: "Spotlight",
        custom: { canDelete: false, displayName: "Spotlight Section" },
        parent: "ROOT",
        hidden: false,
        nodes: [],
        linkedNodes: {},
    },
};
